import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Select, EAA_Memo, EAA_Btn, EAA_Time } from '~/components/EditAndAddItem';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import PageTitle from '~/components/PageTitle';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import PageTree from './PageTree';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import '~/font.css';

const modeInfo = {
  '': {
    title: '',
  },
  add: {
    title: '權限新增',
  },
  edit: {
    title: '權限編輯',
  },
  view: {
    title: '權限檢視',
  },
};

class AddAndEdit extends Component {
  state={ idData: {}, old_idData: {}, mode: '', canSend: true, fcValue: [], old_fcValue: [], errorAry: [] }
  componentDidMount () {
    const { id, mode = '', getAryIdDetail, setPageText, getRoleTypeList } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getAryIdDetail(id);
    getRoleTypeList();
  }

  componentDidUpdate (preProps) {
    const { aryIdDetail: preAryIdDetail = {} } = preProps;
    const { mode, aryIdDetail = {} } = this.props;
    if (Object.keys(preAryIdDetail).length === 0 && Object.keys(aryIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ idData: aryIdDetail, old_idData: aryIdDetail });
      const { functions = [] } = aryIdDetail;
      const ary = [];
      const handleList = (l = [], func = () => {}) => {
        for (const o of l) {
          if (o.check)func(o.id);
          if ((o.list || []).length > 0)handleList(o.list, func);
        }
      };
      handleList(functions, value => ary.push(value));
      this.setState({ idData: aryIdDetail, old_idData: aryIdDetail, fcValue: ary, old_fcValue: ary });
    }
  }

  componentWillUnmount () {
    this.props.clearKey('PageText');
    this.props.clearKey('AryIdDetail');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }) => {
    const { idData: body } = this.state;
    const idData = JSON.parse(JSON.stringify(body));
    idData[label] = data;
    this.setState({ idData });
  }

  atyDataChange=(ary = []) => {
    const { fcValue: array } = this.state;
    const fcValue = JSON.parse(JSON.stringify(array));
    for (let i = 0; i < ary.length; i++) {
      if (fcValue.indexOf(ary[i]) > -1) {
        fcValue.splice(fcValue.indexOf(ary[i]), 1);
      } else fcValue.push(ary[i]);
    }
    this.setState({ fcValue });
  }

  sendBody=() => {
    const { idData, fcValue } = this.state;
    const body = {
      functions: fcValue,
      memo: idData.memo || '',
      group_name: idData.group_name,
      active: idData.active,
      role_type: idData.role_type,
      fe_report_view: idData.fe_report_view,
      sign: idData.sign,
    };
    return body;
  }

  add=() => {
    this.setState({ canSend: false });
    const body = this.sendBody();
    this.props.postAddNewAry(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    this.setState({ canSend: false });
    const { id, putUpdateAry } = this.props;
    const body = this.sendBody();
    putUpdateAry(id, body);
  }

  filterError=() => {
    const { idData = {} } = this.state;
    // const { active = 2 } = idData;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(idData.group_name) === '',
      returnInputValue(idData.active) === '',
      returnInputValue(idData.role_type) === '',
      returnInputValue(idData.fe_report_view) === '',
      returnInputValue(idData.sign) === '',
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '', atyFunction = {}, roleTypeList = [] } = this.props;
    const { idData = {}, old_idData = {}, canSend, fcValue = [], old_fcValue = [], errorAry } = this.state;
    // const { active = 2 } = idData;
    const { functions: lFunctions = [] } = atyFunction;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck;
    const checkChange = label => isCheck ? (idData[label] || '') !== (old_idData[label] || '') : false;
    const checkFcChange = () => {
      if (!isCheck) return false;
      if (fcValue.length !== old_fcValue.length) return true;
      for (let i = 0; i < fcValue.length; i++) {
        if (old_fcValue.indexOf(fcValue[i]) === -1) {
          return true;
        }
      }
      return false;
    };
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='權限名稱' bol={true} haveChange={checkChange('group_name')} />
              <EAA_Input displayBorder disabled={disabled} hint='AA001' value={returnInputValue(idData.group_name)} onChange={data => { this.changeData({ label: 'group_name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText text='不可為空' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='狀態' bol={true} haveChange={checkChange('active')} />
              <CircleCheckBox disabled={disabled} value={idData.active === 1} onClick={() => { this.changeData({ label: 'active', data: 1 }); }} />
              <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>啟用</div>
              <CircleCheckBox disabled={disabled} value={idData.active === 0} onClick={() => { this.changeData({ label: 'active', data: 0 }); }} />
              <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>停用</div>
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText text='請勾選狀態' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='角色類型' bol={true} haveChange={checkChange('role_type')} />
              <EAA_Select displayBorder disabled={disabled} list={roleTypeList} value={returnInputValue(idData.role_type)} onChange={data => { this.changeData({ label: 'role_type', data }); }} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText text='請選擇' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='前台報表' bol={true} haveChange={checkChange('fe_report_view')} />
              <CircleCheckBox disabled={disabled} value={idData.fe_report_view === 1} onClick={() => { this.changeData({ label: 'fe_report_view', data: 1 }); }} />
              <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>可檢視</div>
              <CircleCheckBox disabled={disabled} value={idData.fe_report_view === 0} onClick={() => { this.changeData({ label: 'fe_report_view', data: 0 }); }} />
              <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>不可檢視</div>
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText text='請勾選' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item />
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='簽核確認' bol={true} haveChange={checkChange('sign')} />
              <CircleCheckBox disabled={disabled} value={idData.sign === 1} onClick={() => { this.changeData({ label: 'sign', data: 1 }); }} />
              <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>簽核權限</div>
              <CircleCheckBox disabled={disabled} value={idData.sign === 0} onClick={() => { this.changeData({ label: 'sign', data: 0 }); }} />
              <div style={{ marginRight: 12, marginLeft: 8, fontSize: 18 }}>無簽核權限</div>
            </EAA_ItemContainer>
            {errorAry[4] && <EAA_ErrorText text='請勾選' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            <EAA_TitleText text='備註說明' haveChange={checkChange('memo')} />
            <EAA_Memo displayBorder disabled={disabled} hint='例如: 使用者姓名，方便查閱' value={returnInputValue(idData.memo)} onChange={data => this.changeData({ label: 'memo', data })} />
          </div>
        </EAA_Row>

        <EAA_Row style={{ alignItems: 'start' }}>
          <EAA_TitleText text='權限' haveChange={checkFcChange()} />
          <div style={{ flex: 1 }}>
            <div className='Noto_Sans_SC' style={{ textAlign: 'start', fontWeight: 500, color: '#747474', fontSize: 16, marginBottom: 7 }}>系統管理權限</div>
            <PageTree disabled={disabled} value={fcValue} label={lFunctions[1]} onChange={this.atyDataChange} />
          </div>
          <div style={{ flex: 1 }}>
            <div className='Noto_Sans_SC' style={{ textAlign: 'start', fontWeight: 500, color: '#747474', fontSize: 16, marginBottom: 7 }}>資料分析服務</div>
            <PageTree disabled={disabled} value={fcValue} label={lFunctions[0]} onChange={this.atyDataChange} />
          </div>
        </EAA_Row>

        <div style={{ height: 16 }} />

        {idData.upd_time && (
          <EAA_Row>
            <EAA_ItemContainer>
              <EAA_TitleText text='上次更新時間' />
              <div>{idData.upd_time}</div>
            </EAA_ItemContainer>
          </EAA_Row>
        )}

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewAry' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutUpdateAry' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  aryIdDetail: state.data.AryIdDetail,
  atyFunction: state.data.AtyFunction,
  roleTypeList: state.data.RoleTypeList,
});
const mapDispatchToProps = dispatch => ({
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getAryIdDetail: id => Actions.getAryIdDetail(dispatch, { id }),
  getRoleTypeList: () => Actions.getRoleTypeList(dispatch),
  postAddNewAry: body => Actions.postAddNewAry(dispatch, { body }),
  clearKey: key => Actions.clearKey(dispatch, { key }),
  putUpdateAry: (id, body) => Actions.putUpdateAry(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
